import React from 'react';
import { Tooltip, tooltipClasses, TooltipProps } from '@mui/material';
import { styled } from '@mui/system';

const CustomTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#3e3d32',
    color: '#ffffff',
    fontSize: '0.875rem',
    borderRadius: '0.3rem',
    padding: '0.4rem 0.65rem',
    boxShadow: '0 0.25rem 0.5rem rgba(0, 0, 0, 0.15)',
    maxWidth: 250,
    textAlign: 'center',
    fontWeight: 'bold',
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: '#3e3d32',
  },
}));

export default CustomTooltip;
